module.exports = {
    devServer: {
        public: 'ppd.geoint.mx',
        host: '0.0.0.0',
        port:8085,
        disableHostCheck: true,
        headers: {
            'Access-Control-Allow-Origin': '*'
        },
        //useLocalIp:false,
        proxy: {
            '/apidev': {
                target: 'http://localhost:3005/',
                changeOrigin: true,
                pathRewrite: {'^/apidev' : ''}
            }
        }

    }
}
